"use strict";

exports.__esModule = true;
exports.detect = detect;

var _utils = require("@bydesign-ui/utils");

function detect(rule, value) {
  var fn = rule.fn,
      errorTip = rule.errorTip;

  if (fn == null) {
    return Promise.resolve();
  }

  try {
    var result = fn(value, this);

    if (result != null && typeof result === 'object' && typeof result.then === 'function') {
      return result.catch(function (e) {
        var str = e == null || typeof e === 'string' ? e || '' : e.message;

        if (str) {
          return Promise.reject((0, _utils.format)(str, rule));
        }

        return Promise.reject(typeof errorTip === 'function' ? errorTip(rule) : typeof errorTip === 'string' ? (0, _utils.format)(errorTip, rule) : 'error');
      });
    }

    return Promise.resolve();
  } catch (e) {
    return Promise.reject(e.message);
  }
}